<template lang="pug">
#new-arrival-message-list
  // title
  .d-flex.flex-row.justify-content-center.mb-1
    .page-title 新着メッセージ
  .mb-3.separator

  b-card.list-card.mb-4(v-if="useFunction('sendMessagesFunction')")
    // family message title
    .list-title.mb-1 送信履歴（家族）
    // family message list
    FamilyHistoryList(@onDetail="onFamilyMessageHistoryDetail")

  b-card.list-card.mb-4(v-if="2 <= planType && useFunction('sendMessagesFunction')")
    // other user message title
    .list-title.mb-1 送信履歴（施設関係者）
    // other user message list
    OtherUserHistoryList(@onDetail="onOtherUserMessageHistoryDetail")

  b-card.list-card.mb-4(v-if="showMenu('opinion') && useFunction('receiveMessagesFunction')")
    // family opinion message title
    .list-title.mb-1 家族からの連絡
    // family opinion message list
    FamilyReceiveMessageList(@onDetail="onFamilyReceiveMessageDetail")

  b-card.list-card(v-if="2 <= planType && useFunction('receiveMessagesFunction')")
    // other user opinion message title
    .list-title.mb-1 施設関係者からの連絡
    // other user opinion message list
    OtherUserReceiveMessageList(@onDetail="onOtherUserReceiveMessageDetail")
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { userStore, mobileMessageHistoryStore, mobileFamilyReceiveMessageStore, mobileOtherUserReceiveMessageStore } from "@/store/store";
import { MobileMessageHistoryState } from "@/store/MobileMessageHistory";
import { MobileFamilyReceiveMessageState } from "@/store/MobileFamilyReceiveMessage";
import { MobileOtherUserReceiveMessageState } from "@/store/MobileOtherUserReceiveMessage";
import { MobileUrl } from "@/commons/constants/MobileUrl";

import { PlanType } from "@/commons/services/Plans";

import FamilyHistoryList from "@/mobile/containers/NewArrivalMessagesList/FamilyHistoryList.vue";
import OtherUserHistoryList from "@/mobile/containers/NewArrivalMessagesList/OtherUserHistoryList.vue";
import { MessageHistoryTableItem } from "../components/tables/MessageHistoryTable.vue";
import FamilyReceiveMessageList from "@/mobile/containers/NewArrivalMessagesList/FamilyReceiveMessageList.vue";
import { FamilyReceiveMessageTableItem } from "@/mobile/components/tables/FamilyReceiveMessageTable.vue";
import OtherUserReceiveMessageList from "@/mobile/containers/NewArrivalMessagesList/OtherUserReceiveMessageList.vue";
import { OtherUserReceiveMessageTableItem } from "../components/tables/OtherUserReceiveMessageTable.vue";

/**
 * ### 新着メッセージコンポーネント
 *
 * - 送信履歴(家族)の返信未読のメッセージのみを表示する
 * - 送信履歴(施設関係者)の返信未読のメッセージのみを表示する
 * - 受信メッセージ(家族)の未確認メッセージのみを表示する
 * - 受信メッセージ(施設関係者)の未確認メッセージのみを表示する
 * - 取得・表示は子コンポーネントで全て行い詳細ボタンを押下された場合の画面遷移だけを本コンポーネントでハンドリングする
 */
@Component({
  components: {
    FamilyHistoryList,
    OtherUserHistoryList,
    FamilyReceiveMessageList,
    OtherUserReceiveMessageList
  }
})
export default class NewArrivalMessagesList extends Vue {
  /** プラン種別 */
  planType: PlanType = PlanType.UNKNOWN;

  /**
   * ### vue lifecycle created
   */
  public created(): void {
    this.planType = userStore.facility.planType;

    return;
  }

  /**
   * ### メッセージ履歴リスト(家族)の詳細ボタン押下イベント
   */
  public onFamilyMessageHistoryDetail(item: MessageHistoryTableItem): void {
    mobileMessageHistoryStore.updateMobileMessageHistoryState({ state: item as MobileMessageHistoryState });
    this.$router.push({ name: MobileUrl.FamilyMessageHistoryDetail, params: { type: "2" } });

    return;
  }

  /**
   * ### メッセージ履歴リスト(施設関係者)の詳細ボタン押下イベント
   */
  public onOtherUserMessageHistoryDetail(item: MessageHistoryTableItem): void {
    mobileMessageHistoryStore.updateMobileMessageHistoryState({ state: item as MobileMessageHistoryState });
    this.$router.push({ name: MobileUrl.OtherUserMessageHistoryDetail, params: { type: "2" } });

    return;
  }

  /**
   * ### 受信メッセージ(家族)の詳細ボタン押下イベント
   */
  public onFamilyReceiveMessageDetail(item: FamilyReceiveMessageTableItem): void {
    mobileFamilyReceiveMessageStore.updateMobileFamilyReceiveMessageState({ state: item as MobileFamilyReceiveMessageState });
    this.$router.push({ name: MobileUrl.FamilyReceiveMessageDetail, params: { type: "2" } });

    return;
  }

  /**
   * ### 受信メッセージ(施設関係者)の詳細ボタン押下イベント
   */
  public onOtherUserReceiveMessageDetail(item: OtherUserReceiveMessageTableItem): void {
    mobileOtherUserReceiveMessageStore.updateMobileOtherUserReceiveMessageState({ state: item as MobileOtherUserReceiveMessageState });
    this.$router.push({ name: MobileUrl.OtherUserReceiveMessageDetail, params: { type: "2" } });

    return;
  }

  /**
   * ### メニュー表示可否
   */
  public showMenu(functionName: string): boolean {
    // Objectのプロパティを動的参照したいが、コンパイルエラーになるのでanyにしてから取得する
    const permittedFunctions: any = userStore.facility.permittedFunctions;
    const showMenu: boolean = permittedFunctions[functionName];

    return showMenu;
  }

  /**
   * ### 一般ユーザーの機能使用可否を返す
   */
  public useFunction(key: string): boolean {
    const functions: any = userStore.user.permissions.functions;
    const used: boolean = functions[key];

    return used;
  }
}
</script>

<style lang="scss" scopeed>
@import "../../styles/mobile/_colors.scss";

#new-arrival-message-list {
  .list-card {
    .card-body {
      padding: 0.5rem 0.75rem !important;
    }

    .list-title {
      color: $font-title;
      font-weight: bold;
      font-size: 1rem;
    }
  }
}
</style>
